import { sendInvitesUiConstaints } from '@constants/send-invites-ui';

const setOpen = value => {
    return { type: sendInvitesUiConstaints.SET_SEND_INVITES_OPEN, payload: value };
};

export const sendInvitesUiActions = {
    setOpen,
};
